module.exports = __webpack_public_path__ + "01_long_black.6325d1d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/01_long_black.png
// module id = 2JKt
// module chunks = 0